import {useState, useEffect} from 'react'
import Author from './Author';

const Collection = ({language, itemHandler}) => {
    console.log(language, "language")
    const [authors, setAuthors] = useState([])
    const [loading, setLoading] = useState(true)
    
    const getAuthors = async (language) => {
        setLoading(true)
        const token = localStorage.getItem("token");
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/subjects/list-authors?language=${language}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        });
        
        if (response.ok) {
            const json = await response.json();
            setAuthors(json)
        }
        setLoading(false)
    }

    useEffect(() => { getAuthors(language) }, [language])

    // Loading state
    if (loading) {
        return (
            <div className="flex justify-center items-center p-8 w-full">
                <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 w-full">
                    {[...Array(12)].map((_, i) => (
                        <div key={i} className="bg-white rounded-lg border border-gray-200 p-3 shadow-sm animate-pulse">
                            <div className="border-b border-gray-200 pb-1 mb-2">
                                <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto"></div>
                            </div>
                            <div className="flex flex-wrap gap-2 justify-center">
                                <div className="h-32 w-24 bg-gray-200 rounded"></div>
                                <div className="h-32 w-24 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    // Empty state
    if (authors.length === 0 && !loading) {
        return (
            <div className="text-center py-12 w-full">
                <div className="text-gray-400 text-6xl mb-4">📚</div>
                <p className="text-gray-500 text-lg">No books found in the {language} collection</p>
            </div>
        )
    }

    return (
        <div className="flex flex-col w-full">
            <div className='grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 w-full'>
                {authors && authors.map((item, i) => (
                    <div 
                        key={item + i} 
                        className="bg-white rounded-lg border border-gray-200 p-3 shadow-sm hover:shadow-lg hover:border-blue-300 transition-all duration-200 transform hover:-translate-y-1"
                    >
                        <Author 
                            author={item} 
                            language={language} 
                            itemHandler={(state) => itemHandler(state)}
                        />
                    </div>
                ))}
            </div>                
        </div>
    )
}

export default Collection;